import { render, staticRenderFns } from "./ElementCountDownComp.vue?vue&type=template&id=83cf0806&scoped=true&"
import script from "./ElementCountDownComp.vue?vue&type=script&lang=js&"
export * from "./ElementCountDownComp.vue?vue&type=script&lang=js&"
import style0 from "./ElementCountDownComp.vue?vue&type=style&index=0&id=83cf0806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cf0806",
  null
  
)

export default component.exports